export default __webpack_public_path__ + "static/media/Dr-Madhura-C.6e15988e.jpg";